import { render, staticRenderFns } from "./ChatStrategyCard.vue?vue&type=template&id=13f5678f&scoped=true"
import script from "./ChatStrategyCard.vue?vue&type=script&lang=js"
export * from "./ChatStrategyCard.vue?vue&type=script&lang=js"
import style0 from "./ChatStrategyCard.vue?vue&type=style&index=0&id=13f5678f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f5678f",
  null
  
)

export default component.exports